function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19,
  stroke: "#00478C",
  strokeWidth: 2
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.157 10.732a2.5 2.5 0 010 3.536l-15.82 15.818a2.5 2.5 0 01-3.535 0l-6.403-6.402a2.5 2.5 0 013.535-3.536l4.636 4.635 14.051-14.05a2.5 2.5 0 013.536 0z",
  fill: "#fff"
});
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgCheck;